import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export interface CreateCustomerPortalRequest {
  return_url: string;
}

export interface CreateCustomerPortalResponse {
  success: boolean;
  portal_session_id: string;
  portal_session_url: string;
}

export const useCreateCustomerPortal = () => {
  const userToken = useAuth()?.userToken ?? "";
  const activeOrganization = useActiveOrganization();

  return useMutation({
    mutationFn: async ({
      return_url,
    }: CreateCustomerPortalRequest): Promise<CreateCustomerPortalResponse> =>
      fetch(ENDPOINTS.billing.customer_portal, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          organization_id: activeOrganization.data?.id,
          return_url,
        }),
      }).then(handleResponse),
    onSuccess: (result: CreateCustomerPortalResponse) => {
      window.location.href = result.portal_session_url;
    },
    onError: (error: string) => {
      displayErrorToast(error);
    },
  });
};
